var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_732_1677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 4V92M68 20H38C34.287 20 30.726 21.475 28.1005 24.1005C25.475 26.726 24 30.287 24 34C24 37.713 25.475 41.274 28.1005 43.8995C30.726 46.525 34.287 48 38 48H58C61.713 48 65.274 49.475 67.8995 52.1005C70.525 54.726 72 58.287 72 62C72 65.713 70.525 69.274 67.8995 71.8995C65.274 74.525 61.713 76 58 76H24",
    stroke: "#F5F5F5",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_732_1677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSign);
export default __webpack_public_path__ + "static/media/dollar-sign.9dc7befc09fcefb5f1876d96dce2382a.svg";
export { ForwardRef as ReactComponent };